<div style="width: 100%; background: white">
  <markant-footer class="container" style="box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px">
    <a class="footerLeft" slot="heading" [routerLink]="routes.imprint">Impressum</a>
    <a class="footerLeft" slot="heading" [routerLink]="routes.termsOfUse">Nutzungsbedingungen</a>
    <a class="footerLeft" slot="heading" [routerLink]="routes.privacy">Datenschutz</a>
    <!--<a class="footerLeft" slot="heading" (click)="showCookieConsent()" style="cursor:pointer">Cookie Einstellungen</a> -->
    <a slot="content" href="https://www.markant.com">
      <img class="footer-image" src="./assets/svg/machesmarkant.svg" alt="markant.com" />
    </a>
  </markant-footer>
</div>
